import React, { useEffect, useState } from 'react';
import { profileAPI } from './SellerApi';

export const SellerProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');
  const [tab, setTab] = useState('personal');

  useEffect(() => {
    profileAPI.get()
      .then(r => setProfile(r.data))
      .catch(() => {
        const u = JSON.parse(localStorage.getItem('seller_user') || '{}');
        setProfile({
          firstName: u.firstName || '', lastName: u.lastName || '', email: u.email || '', mobile: u.mobile || '',
          businessName: u.businessName || '', businessCategory: u.businessCategory || 'Apparel',
          gst: u.gst || '', pan: u.pan || '', addressLine1: u.addressLine1 || '', addressLine2: u.addressLine2 || '',
          city: u.city || '', state: u.state || 'Tamil Nadu', pincode: u.pincode || ''
        });
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true); setSuccess('');
    try {
      if (tab === 'personal') {
        await profileAPI.update(profile);
      } else {
        await profileAPI.updateAddress(profile);
      }
      setSuccess('Profile specifications synchronized perfectly.');
      localStorage.setItem('seller_user', JSON.stringify(profile));
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      alert("Failed to synchronize changes.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="sp-skeleton" style={{ height: 300 }} />;

  return (
    <div className="sp-card">
      <div className="sp-orders-header" style={{ marginBottom: '1.5rem' }}>
        <div className="sp-card-title">Merchant Hub Specifications</div>
        <div className="sp-tabs">
          <button className={`sp-tab ${tab === 'personal' ? 'active' : ''}`} onClick={() => setTab('personal')}>Business Info</button>
          <button className={`sp-tab ${tab === 'address' ? 'active' : ''}`} onClick={() => setTab('address')}>Fulfillment Node</button>
        </div>
      </div>

      {success && <div className="sp-alert success" style={{ marginBottom: '1rem' }}>{success}</div>}

      {tab === 'personal' ? (
        <div className="sp-form-grid">
          <div className="sp-input-row">
            <div className="sp-input-group"><label className="sp-label">First Name</label><input className="sp-input" value={profile.firstName} onChange={e => setProfile({ ...profile, firstName: e.target.value })} /></div>
            <div className="sp-input-group"><label className="sp-label">Last Name</label><input className="sp-input" value={profile.lastName} onChange={e => setProfile({ ...profile, lastName: e.target.value })} /></div>
          </div>
          <div className="sp-input-row">
            <div className="sp-input-group"><label className="sp-label">Email Access Node</label><input className="sp-input" value={profile.email} onChange={e => setProfile({ ...profile, email: e.target.value })} /></div>
            <div className="sp-input-group"><label className="sp-label">Contact Link</label><input className="sp-input" value={profile.mobile} disabled /></div>
          </div>
          <div className="sp-input-group"><label className="sp-label">Corporate Registered Entity Title</label><input className="sp-input" value={profile.businessName} onChange={e => setProfile({ ...profile, businessName: e.target.value })} /></div>
          <div className="sp-input-row">
            <div className="sp-input-group"><label className="sp-label">GSTIN ID</label><input className="sp-input" value={profile.gst} onChange={e => setProfile({ ...profile, gst: e.target.value })} /></div>
            <div className="sp-input-group"><label className="sp-label">Pan Registry</label><input className="sp-input" value={profile.pan} onChange={e => setProfile({ ...profile, pan: e.target.value })} /></div>
          </div>
        </div>
      ) : (
        <div className="sp-form-grid">
          <div className="sp-input-group"><label className="sp-label">Dispatch Line 1</label><input className="sp-input" value={profile.addressLine1} onChange={e => setProfile({ ...profile, addressLine1: e.target.value })} /></div>
          <div className="sp-input-group"><label className="sp-label">Dispatch Line 2</label><input className="sp-input" value={profile.addressLine2} onChange={e => setProfile({ ...profile, addressLine2: e.target.value })} /></div>
          <div className="sp-input-row">
            <div className="sp-input-group"><label className="sp-label">City Core</label><input className="sp-input" value={profile.city} onChange={e => setProfile({ ...profile, city: e.target.value })} /></div>
            <div className="sp-input-group">
              <label className="sp-label">State Hub</label>
              <select className="sp-select" value={profile.state} onChange={e => setProfile({ ...profile, state: e.target.value })}>
                {['Tamil Nadu', 'Kerala', 'Karnataka', 'Andhra Pradesh', 'Telangana'].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div className="sp-input-group"><label className="sp-label">Pincode Route Target</label><input className="sp-input" maxLength={6} value={profile.pincode} onChange={e => setProfile({ ...profile, pincode: e.target.value })} /></div>
        </div>
      )}

      <button className="sp-btn-primary" style={{ marginTop: '1.5rem' }} onClick={handleSave} disabled={saving}>
        {saving ? 'Synchronizing Base...' : 'Commit Operational Updates'}
      </button>
    </div>
  );
};